import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';  // Importa el archivo de traducción en inglés
import es from './translations/es.json';  // Importa el archivo de traducción en español
import sk from './translations/sk.json';  // Importa el archivo de traducción en eslovaco
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)  // Conectar react-i18next con i18next
  .init({
    resources: {
      en: { translation: en },  // Asocia las traducciones al idioma inglés
      es: { translation: es },  // Asocia las traducciones al idioma español
      sk: { translation: sk },  // Asocia las traducciones al idioma eslovaco
    },
    // No fijar `lng` aquí -- eso anularía lo que LanguageDetector recupera de
    // su caché (localStorage) y forzaría inglés en cada carga, aunque el
    // usuario hubiera elegido español antes. fallbackLng solo aplica si
    // LanguageDetector no encuentra nada guardado.
    fallbackLng: "en",        // Idioma de respaldo
    interpolation: {
      escapeValue: false,     // React ya se encarga de escapar los valores
    },
  });

export default i18n;

